import React from "react";
import "../../stylesheet/components/media/MediaInfo.scss";

const InfoSectionParent: React.FC<{
  label: string;
  children?: React.ReactNode;
}> = ({ label, children }) => {
  return (
    <>
      <p className="bold d-none d-md-block">{label}:</p>
      <div className="info-child-wrapper">{children}</div>
    </>
  );
};

export default InfoSectionParent;
